import { generateQueryKey } from 'query';

export * from './useNodeUserQuery';

export const getUserNodeQuery = ({ railsId }: { railsId: string }) => generateQueryKey(['users', 'node', railsId]);
